import { render, staticRenderFns } from "./AddressManualSelector.vue?vue&type=template&id=21d6a43c"
import script from "./AddressManualSelector.vue?vue&type=script&lang=js"
export * from "./AddressManualSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports